import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { List } from 'linqts';
import { toLower } from 'lodash-es';
import { Jocker } from '../../lottoloca-commom/lottery-modex';
import { GridNumber, LottolocaNumber } from '../../models/grid-number.model';

@Component({
  selector: 'kt-grid-jockers',
  templateUrl: './grid-jockers.component.html',
  styleUrls: ['./grid-jockers.component.scss']
})
export class GridJockersComponent implements OnInit, OnChanges {


  @Input() public cols: number = 10;
  @Input() public rows: number = 10;
  @Input() public jockerList: Jocker[] = [];
  @Input() public headerNumberList: LottolocaNumber[] = [];
  @Input() public checkedJockers: string = "";
  @Input() public max = 100;
  @Input() public readOnly = false;

  public _gridNumbers: GridNumber[] = [];

  settingState: string;
  numberTypeSelected: string = "normal";
  normalCount: any;
  public gridNumbersList: List<GridNumber> = new List<GridNumber>();


  @Output() public jockersSelectedChange: EventEmitter<number[]> = new EventEmitter();


  filterTypes: any[];

  public minDefault: number = 0;

  public maxDefault: number = 0;
  public count: number = 0;
  public maxNumber: number;
  public filterName: string = "";

  _error: string;
  rowHeight: string;
  public  _headerNumberListLength: number;

  constructor() { }

  ngOnInit() {

    this.adjusts();
  }

  adjusts() {
    this.rowHeight = "1.5:1";

    if (this.cols < 10 && this.cols > 4) {
      this.rowHeight = "3:1";
    }
    else if (this.cols <= 4) {
      this.rowHeight = "4:1";
    }
  }


  ngOnChanges(changes: SimpleChanges): void {

    this.adjusts();
    this._gridNumbers = [];
    this.gridNumbersList.Clear();

    let splited = this.checkedJockers.trim().split(' ');

 

    if (this.headerNumberList == null) {
      this.headerNumberList = [];
    }

   this._headerNumberListLength = this.headerNumberList.length;

    for (let i of this.jockerList) {
      let gridNumber = new GridNumber();
      gridNumber.value = i.key;
      gridNumber.name = i.name;



      if (splited.some(x => Number(x) == i.key)) {
        gridNumber.state = "selected";
      }
      else {
        gridNumber.state = "unselected";
      }

      gridNumber.numberType = "normal";

   //   this._gridNumbers.push(gridNumber);
      this.gridNumbersList.Add(gridNumber);

    }
  }




  public mouseDown(gridNumber: GridNumber, event: MouseEvent): void {



    if (!this.readOnly) {
      if (gridNumber.state == "selected") {
        this.settingState = "unselected";
      }
      else {
      
          this.settingState = "selected";
   
      }

      this.mouseOver(gridNumber, event);
    }
  }
  public mouseOver(gridNumber: GridNumber, event: MouseEvent): void {

   
    if (!this.readOnly) {
      let number = gridNumber;

   
            
      if(this.gridNumbersList.Where(x => x.state === "selected" && x.numberType == "normal").Count() >=   this.max
        && this.settingState == "selected") 
      {
        return;
      }

      if (event.which == 1) {

        number.state = this.settingState;

        if (number.state == "selected") {
          number.numberType = this.numberTypeSelected;
        }
        else {
          number.numberType = "normal";
        }

        this.normalCount = this.gridNumbersList.Where(x => x.state === "selected" && x.numberType == "normal").Count();

        this.jockersSelectedChange.emit(this.gridNumbersList
          .Where(x => x.state === "selected" && x.numberType == "normal")
          .Select(x => x.value)
          .ToArray());


      } else if (event.which == 3) {
        //console.log('mouse down state with right click');
      } else {
        // console.log('mouse update');
      }

    }

  }



}
